const elders = [
    "Late Shri Jaipal Das Tulsija & Smt. Vimla Tulsija",
];



const BlessingsHeading = () => {
    return (
        <div className="blessings-heading">
            <p className="blessings-title">
                With the blessings of Divine and our Elders
            </p>
            {elders.map((names) => (
                <h3 key={names} className="blessings-names">
                    {names}
                </h3>
            ))}
            <p className="blessings-message">
                together with their families request the honour of your presence{" "}
                <br />
                for the wedding celebration of their Grand Daughter
            </p>
        </div>
    );
};

export default BlessingsHeading;
